import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const URL = process.env.VUE_APP_BASE_URL;

const axios = createAxiosInstance(URL, { enableGuestAccess: true, rejectOn5xx: true });

export const fetchLanguages = (params = { page_size: 1000 }) => {
    return axios.get('/api/v1/languages/', { params });
};

export const fetchGenerateTypes = (params = {}) => {
    return axios.get('/api/v1/book_parts/generate_types/', { params });
};

export const fetchDeviceProfiles = (params = {}) => {
    return axios.get('/api/v1/device_profiles/', { params });
};

// @todo move to pauses?
export const fetchBumps = (params = {}) => {
    return axios.get('/api/v1/prerecorded_audios/', { params });
};

export const fetchSoundSettings = (params = {}) => {
    return axios.get('/api/v1/sound_setting/sound_settings/', { params });
};

export const fetchSpecialChars = (params = {}) => {
    return axios.get('/api/v1/admin/phrase_dictionary/special_symbols/symbols/', { params });
};

export const addPhoneme = data => {
    return axios.post('/api/v1/admin/speech_settings/phonemes/', data);
};
